import React from 'react';
import RegisterForm from '../../components/Auth/RegisterForm';
import './RegisterPage.css';

const RegisterPage = () => {
  return (
    <div className="register-page">
      <div className="centered-container">
        <RegisterForm />
      </div>
    </div>
  );
};

export default RegisterPage;